import styled, { css } from 'styled-components'

import { fadeIn } from '@/theme/animations'

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
`

interface TriggerWrapperProps {
  $fullWidth?: boolean
}

export const TriggerWrapper = styled.div<TriggerWrapperProps>`
  display: flex;
  align-items: center;
  min-width: 0;
  width: fit-content;
  ${({ $fullWidth }) => $fullWidth && 'flex: 1; width: 100%;'}
`

export const TriggerButton = styled.button(({ theme }) => {
  return css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: ${theme.space['0']};
    color: ${theme.colors.black500};
    transition: color ${theme.transition.duration.sm};

    &:hover {
      color: ${theme.colors.black700};
    }

    &:focus {
      outline: none;
    }
  `
})

export const TooltipContent = styled.div(({ theme }) => {
  return css`
    z-index: ${theme.zIndex.level4};
    width: max-content;
    max-width: 40rem;
    background-color: ${theme.colors.black800};
    border-radius: ${theme.border.radius['6']};
    padding: ${theme.space['12']} ${theme.space['16']};
    box-shadow: ${theme.shadow.md};
    animation: ${fadeIn} ${theme.transition.duration.sm} ease-in-out;
  `
})

export const TooltipText = styled.div(({ theme }) => {
  return css`
    color: ${theme.colors.white};
    font-size: 1.2rem;
    line-height: 1.6rem;
    font-weight: 500;
    // Note: without this, a single unbroken "word" longer than TooltipContent's 40rem
    // max-width overflows the tooltip box instead of wrapping - same underlying gap as
    // Typography's breakLines fix, just in this component's own wrapping content.
    word-break: break-word;
  `
})
